<template>
  <div class="tab-header">
    <div class="container-fluid">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <router-link :to="`/detail/origin/tab/1`" class="nav-link" :class="{'active show': current === 1}">
            個人資訊
          </router-link>
        </li>
        <li class="nav-item" v-if="CustInfo.ID !== '' || CustInfo.serNo !== ''">
          <router-link :to="`/detail/${customerId}/tab/2`" class="nav-link" :class="{'active show': current === 2,}">
            家戶關係
          </router-link>
        </li>
        <li class="nav-item" v-else>
          <p class="nav-link disabled">
            家戶關係
          </p>
        </li>
        <!-- <li class="nav-item" v-if="CustInfo.ID !== ''">
          <router-link :to="`/detail/${customerId}/tab/2`" class="nav-link" :class="{'active show': current === 2,}">
            家戶關係
          </router-link>
        </li>
        <li class="nav-item" v-else>
          <p class="nav-link disabled">
            家戶關係
          </p>
        </li> -->
        <li class="nav-item">
          <router-link :to="`/detail/${customerId}/tab/3`" class="nav-link" :class="{'active show': current === 3}">
            拜訪記錄
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="`/detail/${customerId}/tab/4`" class="nav-link" :class="{'active show': current === 4}">
            保單資訊
          </router-link>
        </li>
        <!-- <li class="nav-item" v-else>
          <p class="nav-link disabled">
            保單資訊
          </p>
        </li> -->
        <li class="nav-item" v-if="CustInfo.ID !== ''">
          <router-link :to="`/detail/${customerId}/tab/5`" class="nav-link" :class="{'active show': current === 5}">
            服務歷程
          </router-link>
        </li>
        <li class="nav-item" v-else>
          <p class="nav-link disabled">
            服務歷程
          </p>
        </li>
        <li class="nav-item" v-if="CustInfo.ID !== ''">
          <router-link :to="`/detail/${customerId}/tab/6`" class="nav-link" :class="{'active show': current === 6}">
            申辦進度
          </router-link>
        </li>
        <li class="nav-item" v-else>
          <p class="nav-link disabled">
            申辦進度
          </p>
        </li>
        <li class="nav-item" v-if="CustInfo.ID !== '' && HasHousingLoans">
          <router-link :to="`/detail/${customerId}/tab/7`" class="nav-link" :class="{'active show': current === 7}">
            房貸資訊
          </router-link>
        </li>
        <!-- <li class="nav-item" v-else>
          <p class="nav-link disabled">
            房貸資訊
          </p>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "TabHeader",
  props: {
    customerId: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapGetters([ 'CustInfo','HasHousingLoans'])
  }
}
</script>

<style>

</style>
